import React, { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createQueryClient } from './queryClient';

interface ApiProviderProps {
  children: ReactNode;
  queryClient?: QueryClient;
}

/**
 * Provider component that sets up TanStack Query for the application
 */
export const ApiProvider: React.FC<ApiProviderProps> = ({
  children,
  queryClient: providedQueryClient
}) => {
  // Use provided query client or create a new one
  const queryClient = providedQueryClient || createQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* TODO: Re-enable devtools when TypeScript is upgraded to 4.1+ (currently 3.9.9) */}
      {/* DevTools require template literal types: `${T}Left` | `${T}Right` etc. */}
    </QueryClientProvider>
  );
};

export default ApiProvider;